export default __webpack_public_path__ + "static/media/befly.934e3fce.png";